<app-top-section></app-top-section>
<section>
  <h2 class="text-center">
    {{ 'gamePlay.overtime.makeSelection' | transloco }}
  </h2>
  <div class="flex flex-row flex-wrap w-full h-full">
    <div class="w-full sm:w-1/2">
      <button (click)="homePossession()" class="primary-action-btn" data-testid="homePossession">
        <div class="teams">{{ game.game.homeTeam.teamShortName }}</div>
      </button>
    </div>
    <div class="w-full sm:w-1/2">
      <button (click)="awayPossession()" class="primary-action-btn" data-testid="awayPossession">
        <div class="teams">{{ game.game.awayTeam.teamShortName }}</div>
      </button>
    </div>
  </div>
</section>
